/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Aiflowvariantlabel3Inputs */

const en_aiflowvariantlabel3 = /** @type {(inputs: Aiflowvariantlabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variant ${i?.number}`)
};

const de_aiflowvariantlabel3 = /** @type {(inputs: Aiflowvariantlabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Variante ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Variant {number}" |
*
* @param {Aiflowvariantlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowvariantlabel3 = /** @type {((inputs: Aiflowvariantlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowvariantlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowvariantlabel3(inputs)
	return de_aiflowvariantlabel3(inputs)
});
export { aiflowvariantlabel3 as "aiFlowVariantLabel" }